type NullishString = string | null | undefined;

/**
 * Returns an error message when a given value is "nullish", or the placeholder "dash" value
 * @param v
 * @returns
 */
export const notDash = (v: NullishString): string => {
  if (v === "-" || v === null || v === undefined) {
    return "Choose a non '-' value";
  }
  return "";
};

/**
 * Returns an error message when a given value is "nullish" or an empty string
 * @param v
 * @returns
 */
export const notEmpty = (v: NullishString): string => {
  if (v === "" || v === null || v === undefined) {
    return "This is a required field";
  }
  return "";
};
